import { render, staticRenderFns } from "./PromotionPage.vue?vue&type=template&id=ebc1d35c&scoped=true"
import script from "./PromotionPage.vue?vue&type=script&lang=js"
export * from "./PromotionPage.vue?vue&type=script&lang=js"
import style0 from "./PromotionPage.vue?vue&type=style&index=0&id=ebc1d35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc1d35c",
  null
  
)

export default component.exports